import { render } from "./TwoColumnSelector.vue?vue&type=template&id=8d8b1e5a&scoped=true&ts=true"
import script from "./TwoColumnSelector.vue?vue&type=script&lang=ts"
export * from "./TwoColumnSelector.vue?vue&type=script&lang=ts"

import "./TwoColumnSelector.vue?vue&type=style&index=0&id=8d8b1e5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8b1e5a"]])

export default __exports__